<template>
  <hm-content title="">
  <div class="flex act-container">
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >
          <div class="ruleForm_title mb20">
            1.规则基本信息
          </div>
          <el-form-item label="规则名称" prop="ruleName">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.ruleName"
              placeholder="请输入规则名称"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <div class="width45">
            <div class="ruleForm_title mb20">
              2.命中第三方词库
            </div>
            <div class="flex item-center">
              <el-button size="small" @click="addSysDictionary" type="primary"
                >选择官方词库</el-button
              >
              <div class="form_tips">用户搜索的词与选择的词相同时出现筛选条件</div>
              <!-- <div class="flex flex-end">
                <div class="success">导出模版<span class="delete-icon hmicon icon-daochu ml5"></span></div>
                <div class="danger ml20">导入数据<span class="delete-icon hmicon icon-daoru ml5"></span></div>
              </div> -->
            </div>
            <div class="table-wrapper mt20">
              <el-table
                :data="ruleForm.sysGroupIds"
                style="width: 100%"
                stripe
                border
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                  :index="index => index + (sysGroupIdsCurrentPage - 1) * sysGroupIdsPageSize + 1"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="官方词库"
                  prop="groupName"
                >
                </el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="150px">
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-tooltip
                        class="item"
                        content="删除"
                        placement="top"
                        style="color: #E50065"
                      >
                        <div class="pointer mr10 no-bg" @click="sysGroupIdsRemove(scope.row,scope.$index)">
                          <span class="hmicon icon-shanchu blue"></span>
                        </div>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="hm-pagination mb20">
                <el-pagination
                  background
                  :total="sysGroupIdsTotal"
                  @current-change="sysGroupIdsPaging"
                  @size-change="sysGroupIdsHandleSizeChange"
                  layout="total, sizes, prev, pager, next, jumper"
                  :current-page="sysGroupIdsCurrentPage"
                ></el-pagination>
              </div> -->
            </div>
          </div>
          <div class="width45">
            <div class="ruleForm_title mb20">
              3.命中自定义词
            </div>
            <div class="flex item-center">
              <el-button size="small" @click="addWord" type="primary"
                >添加自定义命中词</el-button
              >
              <div class="form_tips">用户搜索的词与选择的词相同时出现筛选条件</div>
            </div>
            <div class="table-wrapper mt20">
              <el-table
                :data="ruleForm.wordList"
                style="width: 100%"
                stripe
                border
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                  :index="index => index + (wordListCurrentPage - 1) * wordListPageSize + 1"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="自定义词"
                  prop="word"
                >
                </el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="150px">
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <!-- <el-tooltip class="item" content="编辑" placement="top">
                        <button class="pointer mr10 no-bg" @click="wordListEdit(scope.row)">
                          <span class="hmicon icon-bianji blue"></span>
                        </button>
                      </el-tooltip> -->
                      <el-tooltip
                        class="item"
                        content="删除"
                        placement="top"
                        style="color: #E50065"
                      >
                        <div class="pointer mr10 no-bg" @click="wordListRemove(scope.row,scope.$index)">
                          <span class="hmicon icon-shanchu blue"></span>
                        </div>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="hm-pagination mb20">
                <el-pagination
                  background
                  :total="wordListTotal"
                  @current-change="wordListPaging"
                  @size-change="wordListHandleSizeChange"
                  layout="total, sizes, prev, pager, next, jumper"
                  :current-page="wordListCurrentPage"
                ></el-pagination>
              </div> -->
            </div>
          </div>
          <div class="width45">
            <div class="ruleForm_title mb20">
              4.展示筛选条件
            </div>
            <div class="flex item-center">
              <el-button size="small" @click="showFilterList" type="primary"
                >选择筛选属性</el-button
              >
            </div>
            <div class="table-wrapper mt20">
              <el-table
                :data="ruleForm.attrList"
                style="width: 100%"
                stripe
                border
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                  :index="index => index + (attrListCurrentPage - 1) * attrListPageSize + 1"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="属性值"
                  prop="attributeValue"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="属性"
                  prop="attributeName"
                >
                </el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="150px">
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <!-- <el-tooltip class="item" content="编辑" placement="top">
                        <button class="pointer mr10 no-bg" @click="attrListEdit(scope.row)">
                          <span class="hmicon icon-bianji blue"></span>
                        </button>
                      </el-tooltip> -->
                      <el-tooltip
                        class="item"
                        content="删除"
                        placement="top"
                        style="color: #E50065"
                      >
                        <button class="pointer mr10 no-bg" @click="attrListRemove(scope.row,scope.$index)">
                          <span class="hmicon icon-shanchu blue"></span>
                        </button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="hm-pagination mb20">
                <el-pagination
                  background
                  :total="attrListTotal"
                  @current-change="attrListPaging"
                  @size-change="attrListHandleSizeChange"
                  layout="total, sizes, prev, pager, next, jumper"
                  :current-page="attrListCurrentPage"
                ></el-pagination>
              </div> -->
            </div>
          </div>
          
          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
        title="官方词库"
        :visible.sync="dialogVisibleSysDictionary"
        width="800px"
        @close="closeSysDictionary"
      >
      <div slot="title" class="wordList">
        <span>选择官方词库</span>
      </div>
      <div class="content">
        <div class="flex item-center">
          <el-select
            size="small"
            clearable
            placeholder="请选择官方词库"
            v-model="sysDictionarySearchConditions.typeId"
            class="mr20"
          >
            <el-option
              :label="v.typeName"
              :value="v.id"
              v-for="(v, i) in typeNameListAll"
              :key="i"
            ></el-option>
          </el-select>
          <el-input
            size="small"
            clearable
            class="mr20 ipt"
            v-model.trim="sysDictionarySearchConditions.groupName"
            placeholder="请输入官方词库名称"
            maxlength="30"
          ></el-input>
          <el-button size="small" @click="sysDictionarySearch" type="primary"
            >查询</el-button
          >
        </div>
        <div class="table-wrapper mt20">
          <el-table
            :data="sysDictionaryList"
            ref="sysDictionaryTable"
            style="width: 100%"
            stripe
            border
            size="small"   
            @row-click="sysDictionaryTableSelect"         
            @selection-change="sysDictionaryHandleSelectionChange"
          >
            <el-table-column
              type="selection"
              header-align="center"
              align="center"
              width="50"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (sysDictionaryCurrentPage - 1) * sysDictionaryPageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="官方词库"
              prop="groupName"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="typeName"
              label="分类"
            >
            </el-table-column>
          </el-table>
          <div class="hm-pagination mb20">
            <el-pagination
              background
              :total="sysDictionaryListTotal"
              @current-change="sysDictionaryPaging"
              @size-change="sysDictionaryHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="sysDictionaryCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="saveSysDictionary" type="primary" size="small">确定</el-button>
          <el-button @click="closeSysDictionary" type="info" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="词库分类"
        :visible.sync="dialogVisibleWord"
        width="500px"
        @close="closeWord"
      >
      <div slot="title" class="wordList">
        <span>{{wordTypeTitle}}</span>
      </div>
      <div class="content">
        {{wordTypeTitle}}
        <el-input
          size="small"
          clearable
          class="ml20 mr20 ipt"
          v-model.trim="word"
          placeholder="请输入自定义词"
          style="width:200px"
        ></el-input>
      </div>  
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="saveWord" type="primary" size="small">确定</el-button>
        <el-button @click="closeWord" type="info" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="添加筛选属性"
      width="1600px"
      :before-close="qx"
      :visible.sync="dialogVisible"
    >
      <div class="flex">
        <div class=" mr10 " style="width:600px">
          <div class="table-panel flex flex-between">
            <div class="fr" style="width: 100%">
              <el-input
                clearable
                v-model.trim="attributeName"
                placeholder="请输入属性"
                size="small"
                class="ipt mr10 fr"
              >
              </el-input>
              <el-button
                class="fr"
                type="primary"
                size="small"
                @click="attrL2ListSearch"
                >查询</el-button
              >
            </div>
          </div>
          <div class="table-panel">
            <div class="tables">
              <el-table
                stripe
                ref="attrL2List"
                :data="attrL2List"
                style="width: 100%"
                id="table"
                @row-click="attrL2ListTableSelect"
                size="small"
                border
                max-height="500"
                @selection-change="attrL2ListHandleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                >
                </el-table-column>
                <!-- <el-table-column width="36">
                  <template slot-scope="scope">
                    <el-radio
                      :label="scope.row.storeCode"
                      v-model="storeCode"
                      @change.native="getTemplateRow(scope.$index, scope.row)"
                      >&nbsp;</el-radio
                    >
                  </template>
                </el-table-column> -->
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  :index="
                    index => index + (attrL2ListCurrentPage - 1) * attrL2ListPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="attributeName"
                  label="属性"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="valueNum"
                  width="90"
                  label="属性值数"
                ></el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                background
                small
                :pager-count="5"
                :total="attrL2ListTotal"
                @current-change="attrL2ListPaging"
                @size-change="attrL2ListHandleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="attrL2ListCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="mar10 seach_checked">
          <el-button class="btn" type="primary" size="small" @click="searchAttrL3List"
            >预览属性值</el-button
          >
        </div>
        <div class="mr10 w60" style="width:800px">
          <div class="table-panel" style="margin-top:40px">
            <div class="table">
              <el-table
                stripe
                ref="rightData"
                :data="attrL3List"
                style="width: 100%"
                id="table"
                size="small"
                @row-click="rightTableSelect"
                @selection-change="attrL3ListSelectionChange"
                border
                max-height="500"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  :index="
                    index => index + (attrL3ListCurrentPage - 1) * attrL3ListPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="attributeValue"
                    label="属性值"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="attributeName"
                    label="属性"
                ></el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                small
                background
                :total="attrL3ListTotal"
                @current-change="attrL3ListPaging"
                @size-change="attrL3ListHandleSizeChange"
                layout="total,sizes, prev, pager, next, jumper"
                :current-page="attrL3ListCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm()"
          >确 定</el-button
        >
        <el-button size="small" @click="qx">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import { arrayUnique2 } from "@/utils/utils";
import HmForm from "@/components/HmForm";
import { mapGetters } from "vuex";
import * as XLSX from 'xlsx/xlsx'
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {  HmForm },
  data() {
    return {
      sysDictionaryList: [],
      sysDictionaryListTotal: 0,
      sysDictionaryPageSize: 10,
      sysDictionaryCurrentPage: 1,
      dialogVisibleSysDictionary: false,
      sysDictionarySearchConditions: {
        typeId: "",
        groupName: "",
      },
      ruleForm:{
        ruleName: "",
        sysGroupIds: [],
        wordList: [],
        attrList: [],
      },
      sysGroupIdsCurrentPage: 1,
      sysGroupIdsPageSize: 10,
      sysGroupIdsTotal: 0,
      wordTypeTitle: "",
      word: "",
      wordListCurrentPage: 1,
      wordListPageSize: 10,
      wordListTotal: 0,
      sysGroupIds:[],
      attrListCurrentPage: 1,
      attrListPageSize: 10,
      dialogVisible: false,
      attrList: [],
      attrListTotal: 0,
      attributeIdListSelection:[],
      attributeName: "",
      attrListCurrentPage: 1,
      attrListPageSize: 10,
      attrListTotal: 0,
      attrL2ListCurrentPage: 1,
      attrL2ListPageSize: 10,
      attrL2ListTotal: 0,
      attrL2List: [],
      attrL3ListCurrentPage: 1,
      attrL3ListPageSize: 10,
      attrL3ListTotal: 0,
      attrL3List: [],
      attrL3ListRow: [],
      rules:{
        ruleName: [
          { required: true, message: "请输入规则名称", trigger: "blur" },          
        ],
      },
      typeNameList:[],
      typeNameListAll:[],
      currentPageTypeNameList: 1,
      pageSizeTypeNameList: 10,
      typeNameListTotal: 0,
      dialogVisibleWord: false,
    };
  },
  watch: {},
  created() {
    this.queryAttrL2List();
  },
  mounted() {
    this.queryPageListAll();
  },
  computed: mapGetters(["attributeDetails","storeStyle", "shopList","storeBasucList","notRelShopList"]),
  methods: {
    async querySysDictionaryList() {
      const params = {
        pageSize: this.sysDictionaryPageSize,
        pageNo: this.sysDictionaryCurrentPage,
      };
      const searchConditions = JSON.parse(JSON.stringify(this.sysDictionarySearchConditions));
      
      Object.assign(params, searchConditions);
      const { result } = await this.$store.dispatch("sysDictionaryGroupInfoQueryPageList", params);
      const { records, total } = result;
      this.sysDictionaryList = records;
      this.sysDictionaryListTotal = total;
    },
    sysDictionaryPaging(page) {
      this.sysDictionaryCurrentPage = page;
      this.querySysDictionaryList();
    },
    sysDictionaryHandleSizeChange(size) {
      this.sysDictionaryCurrentPage = 1;
      this.sysDictionaryPageSize = size;
      this.querySysDictionaryList();
    },
    addSysDictionary(){
      this.querySysDictionaryList();
      this.dialogVisibleSysDictionary = true;
    },
    closeSysDictionary(){
      this.dialogVisibleSysDictionary = false;
    },
    saveSysDictionary(){
      this.sysDictionaryList.forEach(v=>{
        this.sysGroupIds.forEach(o=>{
          if(v.id === o){
            v.groupId = v.id;
            this.ruleForm.sysGroupIds.push(v);
          }
        })        
      })
      this.ruleForm.sysGroupIds = arrayUnique2(this.ruleForm.sysGroupIds, "id");
      this.dialogVisibleSysDictionary = false;
    },
    sysDictionaryTableSelect(row, column, event) {
      this.$refs.sysDictionaryTable.toggleRowSelection(row);
    },
    sysGroupIdsRemove(row,index){
      this.ruleForm.sysGroupIds.splice(index, 1);
    },
    sysDictionarySearch(){
      this.querySysDictionaryList();
    },
    sysDictionaryHandleSelectionChange(row){
      this.sysGroupIds = row.map(v => v.id);
    },
    // sysGroupIdsPaging(){

    // },
    // sysGroupIdsHandleSizeChange(){

    // },
    // wordListPaging(){

    // },
    // wordListHandleSizeChange(){

    // },
    async saveWord(){
      this.ruleForm.wordList.push({
        word: this.word
      })
      this.dialogVisibleWord = false;
    },
    addWord(){
      this.word = "";  
      this.wordTypeTitle = "添加自定义命中词";
      this.dialogVisibleWord = true;
    },
    closeWord(){
      this.dialogVisibleWord = false;
    },
    async queryAttrL2List(){
      const params = {
        pageSize: this.attrL2ListPageSize,
        pageNo: this.attrL2ListCurrentPage,
        keyWords :this.attributeName,
      };
      const { result } = await this.$store.dispatch("queryAttrL2List", params);
      const { records , total } = result;
      this.attrL2List = records;
      this.attrL2ListTotal = total;
    },
    attrL2ListSearch() {
      this.attrL2ListCurrentPage = 1;
      this.queryAttrL2List();
    },
    attrL2ListPaging(page) {
      this.attrL2ListCurrentPage = page;
      this.queryAttrL2List();
    },
    attrL2ListHandleSizeChange(size) {
      this.attrL2ListCurrentPage = 1;
      this.attrL2ListPageSize = size;
      this.queryAttrL2List();
    },
    showFilterList(){
      this.dialogVisible = true;
    },
    async queryAttrL3List(){
      const { result } = await this.$store.dispatch("queryAttrL3List", {
        attributeIdList: this.attributeIdListSelection,   
        pageSize: this.attrL3ListPageSize,
        pageNo: this.attrL3ListCurrentPage
      });
      const { records , total } = result;
      this.attrL3List = records;
      this.attrL3ListTotal = total;
    },
    attrL3ListPaging(page){
      this.attrL3ListCurrentPage = page;
      this.queryAttrL3List();
    },
    attrL3ListHandleSizeChange(size){
      this.attrL3ListCurrentPage = 1;
      this.attrL3ListPageSize = size;
      this.queryAttrL3List();
    },
    attrL3ListSelectionChange(row) {
      this.attrL3ListRow = row.map(v => v.valueId);
    },
    //左边表格表格选中
    attrL2ListTableSelect(row, column, event) {
      this.$refs.attrL2List.toggleRowSelection(row);
    },
    rightTableSelect(row, column, event) {
      this.$refs.rightData.toggleRowSelection(row);
    },
    confirm() {
      if (this.attrL3ListRow <= 0) {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      } else {
        this.attrL3List.forEach(v=>{
          this.attrL3ListRow.forEach(o=>{
            if(v.valueId === o){
              v.attrType = "value";
              this.ruleForm.attrList.push(v);
            }
          })        
        })
        this.ruleForm.attrList = arrayUnique2(this.ruleForm.attrList, "valueId");
        this.ruleForm.attrList = JSON.parse(JSON.stringify(this.ruleForm.attrList));
        console.log("this.ruleForm.attrList:",this.ruleForm.attrList);
        this.dialogVisible = false;
      }
    },
    attrL2ListHandleSelectionChange(row) {
      this.attributeIdListSelection = row.map(v => v.attributeId);
    },
    // attrListPaging(){
    //   this.attrListCurrentPage = page;
    //   // this.queryAttrL2List();
    // },
    // attrListHandleSizeChange(){
    //   this.attrListCurrentPage = 1;
    //   this.attrListPageSize = size;
    //   // this.queryAttrL2List();
    // },
    wordListRemove(row,index){
      this.ruleForm.wordList.splice(index, 1);
    },
    attrListRemove(row,index){
      this.ruleForm.attrList.splice(index, 1);
    },
    async queryPageList(){
      let params = {
        pageSize: this.pageSizeTypeNameList,
        pageNo: this.currentPageTypeNameList,
      }
      const { result } = await this.$store.dispatch("sysDictionaryTypeInfoQueryPageList",params);
      if(result){
        const { records, total } = result;
        this.typeNameList = records;
        this.typeNameListTotal = total;
      }
    },
    async queryPageListAll(){
      let params = {
        pageSize: 9999,
        pageNo: 1,
      }
      const { result } = await this.$store.dispatch("sysDictionaryTypeInfoQueryPageList",params);
      if(result){
        const { records } = result;
        this.typeNameListAll = records;
      }
    },
    searchAttrL3List() {
      if (this.attributeIdListSelection.length) {
        this.attrL3ListCurrentPage = 1;
        this.importData = false;
        this.queryAttrL3List();
      } else {
        this.$message({
          message: "请选择属性",
          type: "warning"
        });
      }
    },
    qx() {
      this.dialogVisible = false;
      this.rest();
    },
    rest() {
      setTimeout(() => {
        
      }, 0);
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          this.$store
            .dispatch("storeDictionaryRuleInfoAdd", params)
            .then((res) => {
              if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            this.$router.back(-1);
          }
        })
      }
     })
    },
    
    //导出模板
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        exportJsonToExcel(
            this.tHeader,
            [[]],
            "模板"
        );
      });
    },
    //导入门店
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = {};
        let formatResultDataList = [];
        formatResult.supplierCode = that.$route.query.storeCode;

        result.map((v, i) => {
          formatResultDataList.push({});
          that.tBody.map((o, index) => {
            formatResultDataList[i][that.tBody[index]] = v[index] ? (v[index] + "").replace(/\s*/g, "") : "";
          });
        });
        formatResult.notRelShopModelList = formatResultDataList;

        that.$store
            .dispatch("importNotRelShop", formatResult)
            .then(res => {
              const { code, result } = res;
              if (code === "0") {
                if (result && result.errList.length > 0) {
                  that.errInputResultshopCode = false;
                  that.errInputResult = result.errList;
                  that.errValidImport = true;
                }
                if (result && result.succList.length > 0) {
                  that.importData = true;
                  that.notRelShopList.records = JSON.parse(JSON.stringify(result.succList));
                  setTimeout(()=>{
                    that.notRelShopList.records.forEach(v=>{
                      that.$refs.rightData.toggleRowSelection(v);
                    })
                  }, 0)
                }
              }
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
  },
};
</script>

<style scoped lang="scss">
.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .bg {
    height: 80px;
    background: linear-gradient(to bottom, #f73030, #f6c0c0, #f5f5f5);
    z-index: -1;
  }
  .add-goods-container {
    width: 100%;
    flex-shrink: 0;
    .ruleForm_title{
      font-size: 16px;
      font-weight: 600;
      color: #222222;
      &::before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
    }
    }
  }
}
.width45{
  width: 45%;
}

.ml5{
  margin-left: 5px;
}
/deep/ .el-pagination__editor.el-input{
  width: 50px !important;
}
.wordList{
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  line-height: 20px;
  border-bottom: solid 1px #DDDDDD;
  padding-bottom: 18px;
}
.form_tips{
  font-size: 14px;
  color: #AAAAAA;
  margin-left: 20px;
}
.seach_checked {
  width: 160px;
  height: 100%;
  padding-top: 20%;
  padding-left: 15px;
  margin-right: 25px;
  box-sizing: border-box;
}
</style>
